module.exports = "/lucky-balls/img/combos/28.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos/28.png
// module id = 228
// module chunks = 0